module.exports = __webpack_public_path__ + "static/media/S1-29-Zartrox-cod49.8c17a17f.png";